import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum StatusPropostaFiltro {
  Negociacao = 'Negociacao',
  PropostaVencida = 'PropostaVencida',
  Documentacao = 'Documentacao',
  EmAndamento = 'EmAndamento'
}
export class StatusPropostaFiltroEnum extends GenericoTipoEnum<StatusPropostaFiltro> {
  static readonly Negociacao = new StatusPropostaFiltroEnum(StatusPropostaFiltro.Negociacao, 'Negociação');
  static readonly PropostaVencida = new StatusPropostaFiltroEnum(StatusPropostaFiltro.PropostaVencida, 'Proposta Vencida');
  static readonly Documentacao = new StatusPropostaFiltroEnum(StatusPropostaFiltro.Documentacao, 'Documentação');
  static readonly EmAndamento = new StatusPropostaFiltroEnum(StatusPropostaFiltro.EmAndamento, 'Em Andamento');
}
